import React, { useContext, useEffect } from "react";
import ReactStars from "react-rating-stars-component";
import "./Product.scss";
import share from "../../assets/images/Icon material-share.png";
import gift from "../../assets/images/240_F_293853409_RKHZIdDyLzzCfFV9tFcR7eYBVvkTsIF9-removebg-preview.png";
import BusinessContext from "context/BusinessContext";
import { connection } from "utils/apiConnection.ts";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

const Product = ({ value, isMain }) => {
  const { setProduct, setComments, setShareLink, bpid } =
    useContext(BusinessContext);
  const auth = useContext(WithAuthentication);

  async function apihandlerShare() {
    let result = await connection("generatelink", {
      uid: auth.userInfo.id,
      bpid: bpid,
      type: 0,
      itemId: value.id,
      fromUrl: window.location.href,
    });
    setShareLink(result.data.link);
  }
  if (!value) return "";
  if (isMain)
    return (
      <a
        className="card product col-8 col-sm-5 col-md-4 col-lg-3 col-xxl-2"
        data-bs-toggle="modal"
        data-bs-target="#SingleProduct"
        href="#"
        onClick={(e) => {
          setProduct(value);
          setComments(value.comments);
        }}
        style={{ cursor: "pointer" }}
      >
        {value.shareLinkStatus == 1 ? (
          <div className="icons">
            <div
              className="roundIcon ShG active"
              data-bs-toggle="modal"
              data-bs-target="#ModalShare"
              onClick={(e) => {
                apihandlerShare();
                setProduct(value);
              }}
            >
              <img src={share} alt="share" />
            </div>
            <div
              className="roundIcon ShG active"
              data-bs-toggle="modal"
              data-bs-target="#ModalPoint"
              onClick={(e) => setProduct(value)}
            >
              <img src={gift} alt="gift" />
            </div>
          </div>
        ) : (
          <div className="icons" style={{ cursor: "default" }}>
            <div className="roundIcon ShG inactive">
              <img src={share} alt="share" />
            </div>
            <div className="roundIcon ShG inactive">
              <img src={gift} alt="gift" />
            </div>
          </div>
        )}

        <div className="pic">
          <img src={value.coverImg} alt="cover" />
        </div>
        <div className="name">{value.title}</div>
        <ReactStars
          count={5}
          value={value.rate != "" ? value.rate : 0}
          size={24}
          isHalf={true}
          edit={false}
          emptyIcon={<i className="far fa-star"></i>}
          halfIcon={<i className="fa fa-star-half-alt"></i>}
          fullIcon={<i className="fa fa-star"></i>}
          activeColor="#ffd700"
        />
      </a>
    );
  else {
    return (
      <div
        className="card product col-8 col-sm-5 col-md-4 col-lg-3 col-xxl-2"
        onClick={(e) => setProduct(value)}
        style={{ cursor: "pointer" }}
      >
        {value.shareLinkStatus == 1 ? (
          <div className="icons">
            <div className="roundIcon ShG active">
              <img src={share} alt="share" />
            </div>
            <div className="roundIcon ShG active">
              <img src={gift} alt="gift" />
            </div>
          </div>
        ) : (
          <div className="icons" style={{ cursor: "default" }}>
            <div className="roundIcon ShG inactive">
              <img src={share} alt="share" />
            </div>
            <div className="roundIcon ShG inactive">
              <img src={gift} alt="gift" />
            </div>
          </div>
        )}

        <div className="pic">
          <img src={value.coverImg} alt="cover" />
        </div>
        <div className="name">{value.title}</div>
        <ReactStars
          count={5}
          value={value.rate != "" ? value.rate : 0}
          size={24}
          isHalf={true}
          edit={false}
          emptyIcon={<i className="far fa-star"></i>}
          halfIcon={<i className="fa fa-star-half-alt"></i>}
          fullIcon={<i className="fa fa-star"></i>}
          activeColor="#ffd700"
        />
      </div>
    );
  }
};

export default Product;
